import { Config } from '../../config';
import axios from 'axios';
import { IAssurance } from '../../types/Assurance';

const AssuranceUrl = `${Config.url.DEVICE_URL}/api/v1/Assurance`;

export const GetAssurance = (onSuccess: (assurance: IAssurance) => void, onFailure: () => void) => {
    axios.get(AssuranceUrl).then((response) => onSuccess(response.data), onFailure);
};
